import RiskDetailsForm from './RiskDetailsForm'

export default RiskDetailsForm
